import HekaLoader from "@/assets/heka-loader.svg?react";

const LoadingPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-12">
      <HekaLoader className="max-w-sm max-h-32" />
    </div>
  );
};

export default LoadingPage;
